<div mat-dialog-title>
  {{'DELETE_PROFILE.delete_profile' | translate}}
  <div class="spacer"></div>
  <mat-icon mat-dialog-close class="close-icon">close</mat-icon>
</div>

<mat-dialog-content>
  <div>
    <mat-icon class="error-icon">error</mat-icon>
  </div>
  <div>
    <span>{{'DELETE_PROFILE.delete_description' | translate}}</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" mat-dialog-close>{{'DELETE_PROFILE.cancel' | translate}}</button>
  <button mat-flat-button color="warn" [mat-dialog-close]="true">{{'DELETE_PROFILE.delete' | translate}}</button>
</mat-dialog-actions>